import React from "react";

import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Card, Col, Container, Row } from "react-bootstrap";

import SectionHeader from "@/components/SectionHeader.component";
import { localizePath } from "@/utils/i18nRoutes";

import i18n from "../../i18n";

interface IPressRelease {
  date: Date;
  title: string;
  description: string;
  location: string;
  // Omitted while the release page is not published yet.
  link?: string;
}

const PressReleaseComponent = (): React.JSX.Element => {
  const { t, language } = i18n;
  const lang = language === "fr" ? "fr" : "en";

  const items: IPressRelease[] = [
    {
      date: new Date(2026, 9, 15),
      title: t("A Home Built from 200,000 Recycled Plastic Bottles"),
      description: t(
        "Québec cleantech company PakVille introduces a faster, more affordable way to build homes while reducing construction’s environmental footprint.",
      ),
      location: "Montréal, Québec",
      link: localizePath("/releases/2026-10-15", lang),
    },

    {
      date: new Date(2026, 4, 8),
      title: t(
        "Canadian Home Solution Builder Partners With National Foundation to Address Indigenous Housing Crisis",
      ),
      description: t(
        "PakVille and The Steven Low Foundation combine sustainable housing innovation with community-informed guidance to help deliver scalable, culturally respectful housing solutions for Indigenous communities across Canada.",
      ),
      location: "Montréal, Québec",
      link: localizePath("/releases/2026-05-08", lang),
    },
  ];

  return (
    <Container>
      <SectionHeader
        eyebrow={t("From PakVille™")}
        title={t("Press Releases")}
        description={t(
          "Official company announcements, project milestones and updates from PakVille™.",
        )}
      />
      <Row>
        {items.map((item) => (
          <Col key={item.title} className="mb-4" sm={6}>
            <Card className="d-flex align-items-center justify-content-center h-100  flex-column rounded">
              <Card.Body
                className="h-100 p-3 d-flex align-items-start flex-column rounded-end"
                style={{ backgroundColor: "#FFFFFF" }}
              >
                <Card.Title
                  className="fs-4 mb-3"
                  style={{ color: "var(--primary-color)" }}
                >
                  <div className="d-flex h6 sectionEyebrow gap-2">
                    {item.date.toLocaleDateString(language, {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })}
                    <div>-</div>
                    {item.location}
                  </div>
                  <div>{item.title}</div>
                </Card.Title>

                <Card.Text className="mb-4">{item.description}</Card.Text>
              </Card.Body>

              {item.link ? (
                <Card.Footer
                  className="d-flex align-items-center justify-content-between w-100 flex-wrap"
                  style={{
                    fontSize: "13px",
                    background: "#FFF",
                    border: "none",
                  }}
                >
                  <a href={item.link} rel="noreferrer" target="_blank">
                    <Button
                      className="btn-outline border-0"
                      size="sm"
                      style={{ marginLeft: "-0.5rem" }}
                      variant="ps-4 pe-2 "
                    >
                      {t("Read Press Release")}
                      <FontAwesomeIcon className="ms-2" icon={faArrowRight} />
                    </Button>
                  </a>
                </Card.Footer>
              ) : null}
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default PressReleaseComponent;
